import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

interface Segment {
  kind: 'passed' | 'failed' | 'blocked' | 'offen';
  width: number;
}

/**
 * Gestapelter Fortschrittsbalken (page-release-freigabe.jsx:81-88). Für Screenreader
 * stumm — die Zahlen stehen in der Legende daneben.
 */
@Component({
  selector: 'app-stack-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="stack-bar" aria-hidden="true" [style.height.px]="height()">
      @for (s of segments(); track s.kind) {
        <div class="stack-bar__segment" [attr.data-kind]="s.kind" [style.width.%]="s.width"></div>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
    }

    .stack-bar {
      display: flex;
      overflow: hidden;
      border-radius: 999px;
      background: var(--to-track);
    }

    .stack-bar__segment {
      &[data-kind='passed'] {
        background: var(--to-chart-passed);
      }
      &[data-kind='failed'] {
        background: var(--to-chart-failed);
      }
      &[data-kind='blocked'] {
        background: var(--to-warn-border);
      }
      &[data-kind='offen'] {
        background: var(--to-track);
      }
    }
  `,
})
export class StackBarComponent {
  readonly passed = input(0);
  readonly failed = input(0);
  readonly blocked = input(0);
  readonly offen = input(0);
  readonly height = input(8);

  protected readonly segments = computed<Segment[]>(() => {
    const parts: [Segment['kind'], number][] = [
      ['passed', this.passed()],
      ['failed', this.failed()],
      ['blocked', this.blocked()],
      ['offen', this.offen()],
    ];
    const total = parts.reduce((sum, [, n]) => sum + n, 0);
    if (total === 0) return [];
    return parts.filter(([, n]) => n > 0).map(([kind, n]) => ({ kind, width: (n / total) * 100 }));
  });
}
